module.exports = __webpack_public_path__ + "src/assets/img/login-bg-img-180.png";